import {FC} from 'react'
import {StickerPackType} from 'entities/messages'
import {useWallet} from 'entities/payment'
import {mediaVariants} from 'shared/lib'
import {Badge} from 'shared/ui/badge'
import {GoCoin} from 'shared/ui/icons'
import styles from './styles.module.scss'

type StickerPackProps = {
  stickerPack: StickerPackType
  onClick: (stickerId: number) => void
}

export const StickerPack: FC<StickerPackProps> = ({stickerPack, onClick}) => {
  const {stickers} = useWallet()

  return (
    <div className={styles.pack}>
      <div className={styles.packHeader}>
        <div className={styles.packName}>{stickerPack.name}</div>
        {
          stickerPack.price
            ? <div className={styles.price}>
              <span>{stickerPack.price}</span>
              <GoCoin />
            </div>
            : <Badge>x{stickers}</Badge>
        }
      </div>
      <div className={styles.stickers}>
        {stickerPack.stickers.map((sticker) =>
          <img
            key={sticker.id}
            src={sticker.data.url + mediaVariants.square256}
            alt='sticker'
            className={styles.sticker}
            onClick={() => onClick(sticker.id)}
          />)}
      </div>
    </div>
  )
}